export default "__VITE_ASSET__D$ngd9mC__"